import moment from 'moment';

export module DateHelper {
	export function isToday(date: Date) {
		const dateToCompare = moment(date);
		const today = moment();
		return dateToCompare.isSame(today, 'day');
	}
}
